"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decidePeriodType = exports.canUsePartDayOption = exports.canUseHalfDayOption = void 0;
const graphql_1 = require("@app/gql-types/graphql");
const canUseHalfDayOption = (shiftsInDay, isAvailabilityOrUnavailability) => shiftsInDay === 1 && !isAvailabilityOrUnavailability;
exports.canUseHalfDayOption = canUseHalfDayOption;
const canUsePartDayOption = (country, vacation) => !(country === 'SK' && vacation);
exports.canUsePartDayOption = canUsePartDayOption;
const decidePeriodType = (defaultValue, halfDayAvailable, partDayAvailable) => {
    let currentPeriodType = defaultValue;
    if (!halfDayAvailable && !partDayAvailable) {
        currentPeriodType = graphql_1.PeriodType.WholeDay;
        return currentPeriodType;
    }
    if (!halfDayAvailable && currentPeriodType === graphql_1.PeriodType.HalfDay) {
        currentPeriodType = graphql_1.PeriodType.PartDay;
    }
    else if (!partDayAvailable && currentPeriodType === graphql_1.PeriodType.PartDay) {
        currentPeriodType = graphql_1.PeriodType.HalfDay;
    }
    return currentPeriodType;
};
exports.decidePeriodType = decidePeriodType;
